<section class="section section--paymentInformation">
  <div class="container">
    <div class="wrapper">
      <div class="content fadeinright animation-duration-300">
        <div class="content__main">
          <article class="mainInfo pb-25">
            <h1>Desembolso</h1>
          </article>

          <article class="paymentSelector">
            <div class="subtitle no-border black pb-15">
              <h2>¿Dónde deseas que depositemos el dinero?</h2>
            </div>

            <div class="paymentSelector__content">
              <p-selectButton [options]="paymentOptions" [(ngModel)]="selectedOption" optionLabel="name" optionValue="value">
                <ng-template let-item pTemplate>
                  <ng-container [ngSwitch]="item.value">

                    <!-- Banking Transfer Template -->
                    <ng-container *ngSwitchCase="optionPayment['banking-transfer']">
                      <div class="paymentSelector__item">
                        <div class="paymentSelector__icon">
                          <i><app-bank-icon color="color"></app-bank-icon></i>
                        </div>
                        <div class="paymentSelector__text">
                          <h3>Transferencia a otros bancos</h3>
                          <p>Tendrás tu dinero máximo en 12 horas hábiles.</p>
                        </div>
                        <div class="paymentSelector__check"></div>
                      </div>
                    </ng-container>

                  </ng-container>
                </ng-template>
              </p-selectButton>
            </div>
          </article>
        </div>

        <div class="content__footer">
          <button pButton pRipple label="Continuar" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded p-button-spaced w-full" (click)="onContinue()" [disabled]="!selectedOption"></button>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Banking Transfer Modal -->
<app-banking-transfer-v3 (gotoStepEvent)="onGotoStep($event)" [request]="request" [visibleBankTransferModal]="visibleBankTransferModal" (onClose)="onCloseBankTransferModal($event)" />
